import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if consent has been given
    const consent = localStorage.getItem('cookieConsent');
    
    if (consent) {
      try {
        const consentData = JSON.parse(consent);
        const consentDate = new Date(consentData.timestamp);
        const currentDate = new Date();
        const monthsDiff = (currentDate - consentDate) / (1000 * 60 * 60 * 24 * 30);
        
        // Show banner if consent is older than 12 months
        if (monthsDiff >= 12) {
          setShowBanner(true);
        }
      } catch (e) {
        // Invalid consent data, show banner
        setShowBanner(true);
      }
    } else {
      // No consent found, show banner
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    // Store consent with timestamp
    const consentData = {
      accepted: true,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consentData));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gray-200 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm md:text-base text-[#5B6B7F] text-center md:text-left">
            We use only essential cookies required for site functionality. By using our site, you agree to this.
          </p>
          <Button
            onClick={handleAccept}
            className="bg-gradient-to-r from-[#FF6B35] to-[#F7931E] hover:from-[#F7931E] hover:to-[#FF6B35] text-white px-8 py-2 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-md whitespace-nowrap"
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
